import { render, staticRenderFns } from "./TestResultsSummary.vue?vue&type=template&id=6215d51c&scoped=true&"
import script from "./TestResultsSummary.vue?vue&type=script&lang=ts&"
export * from "./TestResultsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TestResultsSummary.vue?vue&type=style&index=0&id=6215d51c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215d51c",
  null
  
)

export default component.exports